module.exports = __webpack_public_path__ + "static/media/Cover-Image-Water.c91a4834.jpg";